import React from 'react'
import { Button, Result } from 'antd'

const SubTitle = () => (
  <>
    <div>
      The app you're trying to view either does not exist, or you do not have permission to view it.
    </div>
    <div>
      To request permissions please open a helpdesk ticket. Please provide the full url you are
      trying to access in the ticket description.
    </div>
  </>
)

const Extra = () => (
  <Button shape="round" href={process.env.HELPDESK_TICKET_URL} target="_blank">
    Open Helpdesk Ticket
  </Button>
)

export const NotFound = () => (
  <Result
    extra={<Extra />}
    status="warning"
    style={{ height: '100vh' }}
    subTitle={<SubTitle />}
    title="Page not found"
  />
)
